// @flow

import React from 'react'
import IconBase from 'react-icon-base'

const PlusIcon = (props: Object) => {
  return (
    <IconBase viewBox="0 0 35 35" {...props}>
      <g
        id="icons"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="icon_plus">
          <g id="Group-6" transform="translate(2.000000, 2.000000)">
            <ellipse
              id="Oval-5"
              stroke="#F39200"
              strokeWidth="1.4"
              cx="16"
              cy="16"
              rx="16"
              ry="16"
            ></ellipse>
            <path
              d="M15,15 L11,15 L11,17 L15,17 L15,21 L17,21 L17,17 L21,17 L21,15 L17,15 L17,11 L15,11 L15,15 Z"
              id="Combined-Shape"
              fill="#F39200"
            ></path>
          </g>
        </g>
      </g>
    </IconBase>
  )
}

export default PlusIcon



// WEBPACK FOOTER //
// ./src/components/Icons/PlusIcon.js